export const module = {
  info: {
    name: 'user',
    caption: 'User',
    viewGroup: 'general-modules'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel'
}

export default module
